import { useCertificates } from '../../hooks/useCertificates'
import CertificateItem from './CertificateItem'
import { ResponsiveLayout } from '../../layouts/ResponsiveLayout'
import { TitleBar } from '../../components/NavBar/TitleBar'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { defaultTheme } from '../../styles/themes/defaultTheme'

const Certificates = () => {
    const { t } = useTranslation('certificates')
    const { certificates } = useCertificates()

    return (
        <ResponsiveLayout
            header={null}
            content={
                <CertificatesPage>
                    <TitleBar pageTitle={t('Certificates')} />
                    <CertificatesBlock>
                        {certificates?.length ? (
                            <div className="table">
                                {certificates.map(certificate => (
                                    <CertificateItem key={certificate.id} {...certificate} />
                                ))}
                            </div>
                        ) : (
                            <p>{t('No available certificates')}</p>
                        )}
                    </CertificatesBlock>
                </CertificatesPage>
            }
            aside={null}
            footer={null}
        />
    )
}

export default Certificates

const CertificatesBlock = styled.div`
    .table {
        background-color: white;
        border-radius: ${defaultTheme.borderRadius};
        padding: 20px;
        padding-bottom: 5px;
    }
    margin-bottom: 30px;
`

const CertificatesPage = styled.div`
    .heading {
        h2 {
            font-size: 22px;
            font-weight: 500;
        }
        p.lead {
            font-size: 16px;
            color: ${props => props.theme.color.primary};
        }
    }
    .title {
        font-size: 18px;
        font-weight: 600;
        margin: 10px 0 30px;
    }
`
